import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup } from 'react-bootstrap'
import OptionGroup from './OptionGroup'
import HintField from '../HintField'


export default class GroupedSelectField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    value: PropTypes.string.isRequired,
    optionGroups: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    style: PropTypes.object,
    hint: PropTypes.string,
    errors: PropTypes.object,
    required: PropTypes.bool,
    labelsAsPlaceholders: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    labelsAsPlaceholders: false,
    labelStyle: {},
    inputStyle: {},
    className: ""
  }

  get errorMessage() {
    const { errors, name } = this.props

    if(errors && errors[name]) {
      return errors[name][0]
    }
    return null
  }

  get helpMessage() {
    const { hint } = this.props
    return this.errorMessage || hint || null
  }

  render() {
    const { name, className, label, value, onChange, hint, style, errors, required, optionGroups, labelsAsPlaceholders, labelStyle, inputStyle } = this.props
    const { helpMessage } = this

    return (
      <FormGroup className={`${name} ${className}`} style={{...styles.wrapper, ...style}}>
        { (!labelsAsPlaceholders) &&
          <Form.Label style={{...styles.label, ...labelStyle}}>
            { label }
            { required && <span style={styles.required}>*</span> }
          </Form.Label>
        }
        <Form.Select
          style={{...styles.input, ...inputStyle}}
          name={name}
          value={value}
          onChange={e => onChange(e.target.value)}
          isInvalid={!!this.errorMessage}
        >
          <option value="">
            { labelsAsPlaceholders ? `Choose ${label}` : "" }
          </option>
          { optionGroups.map((optionGroup, index) =>
            <OptionGroup
              key={index}
              label={optionGroup[0]}
              options={optionGroup[1].slice()}
            />
          )}
        </Form.Select>
        <HintField
          hint={hint}
          errorMessage={this.errorMessage}
        />
      </FormGroup>
    )
  }
}

const styles = {
  label: {
    fontSize: 18,
  },
  input: {
    fontSize: 18
  },
  required: {
    color: "#cc0000",
    fontWeight: "normal",
    paddingLeft: 2
  }
}
